const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/feed.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { loadMobileFeedContent, preloadMobilePage } from "@/react/components/Mobile/utils/mobilePageLoaders";
export const Route = createFileRoute("/feed")({
  loader: preloadMobilePage(loadMobileFeedContent),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});